module.exports = __webpack_public_path__ + "img/img_1.736d0215.jpg";